import React, { Component } from "react";
import { Tabs as ATabs } from "antd";

import "./index.less";

class Tabs extends Component {
  render() {
    return (
      <ATabs
        className="nano-tabs"
        {...this.props}
      />
    );
  }
}

export default Tabs;
